import { GearIcon } from './mailNotifyIcons';

/**
 * 「信件即時通知」功能引導的內容（AGUI-1113）。
 *
 * 每頁一個步驟，依使用者實際要做的順序排。`media` 是 GIF 或圖片，放在 `public/mail-notify-guide/` 底下：
 * - `src`：相對於 public 的路徑，例如 `mail-notify-guide/v10/01-outlook.gif`。圖換過就放進新的版本資料夾（v11…），
 *   網址跟著變，瀏覽器才不會拿快取的舊圖（10-19 測試仍看到沒有齒輪的舊圖）
 * - `alt`：圖片說明（螢幕閱讀器會念）
 * - `mobileSrc`（選填）：手機（寬 ≤ 640px）用的直式圖，比例 4:5；沒填就用 `src`，框維持 16:10
 * `media` 為 null 時畫面顯示「示意圖準備中」的預留框；素材到位後只要放檔案並填上 `media`，不必改元件。
 *
 * 改內容時注意與畫面文案一致：按鈕名稱、狀態名稱都以頁面上實際顯示的字為準。
 *
 * 新架構（SA v2.0）沒有「訂閱」這一步了，存好第一條規則就開始通知（D-1013-01）；AGUI-1246 起舊版引導已移除。
 * 用語以新版狀態卡為準（已啟用）；暫停、恢復通知等處理方式由狀態卡自己說明，引導不再提。
 * 第 2 頁同時介紹在對話裡建立規則（agent_mcp mail_rule_create，回覆「確認」才建立）。
 * 10-19 使用者裁決：拿掉與 MyAgent 共用那一頁（共三頁）；第 1 頁的「設定」前加齒輪，與側欄設定入口同一個圖示；
 * 第 2 頁內文只留一句，不放實際信箱範例。`body` 可以是字串或 JSX。
 * 10-19 第二輪：新增第 4 頁（啟用、停用、刪除，GIF），第 3 頁內文拿掉停用／刪除那句；
 * 圖上範例規則一律用「寄件者來自 taiwanmobile.com、主旨包含「全員溝通會議」」，不放個人信箱。
 * 10-19 第三輪（AGUI-1255）：四頁都改成 GIF（整個 MyBro 視窗、照實際操作流程；第 2 頁兩種方式左右滑動；
 *   第 3 頁 M+ 依序跳出兩則通知，接續第 2 頁建立的規則），吉祥物只留第 1 頁、不浮動。
 * 圖檔原始檔與產生方式見桌面「11_新架構/引導圖/v3」（*-anim.html、make-gif.js）。
 */
export const MAIL_NOTIFY_GUIDE_PAGES = [
  {
    id: 'outlook',
    title: '先連結 Outlook',
    body: (
      <>
        到「<GearIcon className="mail-notify-guide__inline-icon" />設定 → 第三方服務」連結 Outlook，MyBro 才讀得到你的新信。
      </>
    ),
    media: {
      // 10-21：吉祥物的對話框往下移到頭上方（v12），其他頁沿用 v10／v11
      src: 'mail-notify-guide/v12/01-outlook.gif',
      alt: '從 MyBro 頁面放大到信件即時通知，按「前往設定」跳出第三方服務，按 Outlook 的「連結」，連好後顯示重新連結與解除連結',
    },
  },
  {
    id: 'rules',
    title: '兩種方式，設定通知規則',
    body: '在「信件即時通知」頁面設定或是在對話中直接說出規則條件。',
    media: {
      // 10-22：對話回覆只留「確認」，拿掉「或「取消」」（v13）
      src: 'mail-notify-guide/v13/02-rules.gif',
      alt: '方式 1 在頁面挑「AI 判讀信件」範本；方式 2 在對話裡說一句，MyBro 回覆要建立的規則',
    },
  },
  {
    id: 'notify',
    title: '新信一到馬上通知你',
    body: '符合規則的新信會透過 M+ 通知你。',
    media: {
      // 10-24：依實際通知，標題改【MyBro/MyAgent】、「摘要：」改「內文：」（v14）
      src: 'mail-notify-guide/v14/03-notify.gif',
      alt: 'M+ 依序收到兩則 Outlook 新信通知，列出規則、寄件者、主旨、時間與內文',
    },
  },
  {
    id: 'manage',
    title: '規則隨時啟用或是停用',
    body: '若不需要時也可以刪除規則。',
    media: {
      src: 'mail-notify-guide/v10/04-manage.gif',
      alt: '在規則卡的狀態選單選啟用或停用；按垃圾桶會先跳出確認視窗，確認後才刪除',
    },
  },
];
